import fetch from '../fetch';
import React from 'react';

import utils from '../../utils';

import { Modal, message } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columns = utils.columns([
    { key: '$index', label: '序号', width: 50 },
    { key: 'xxdm', label: '学校代码', width: 100 },
    { key: 'pkh', label: '排课号', width: 80 },
    { key: 'zc', label: '周次', width: 60 },
    { key: 'xqj', label: '星期几', width: 80 },
    { key: 'termName', label: '学期', width: 140 },
    { key: 'skjc', label: '上课节次', width: 100 },
    { key: 'ydxsrs', label: '应到学生人数', width: 120 },
    { key: 'sdxsrs', label: '实到学生人数', width: 120 },
    { key: 'jsdkqkm', label: '教师到课情况', width: 120, render: value => {
        if (1 === Number(value)) return "正常";
        else if (0 === Number(value)) return "异常";
        else return "";
    }},
    { key: 'kthdqkm', label: '课堂互动情况', width: 120, render: value => {
        if (1 === Number(value || 0)) return "偶尔";
        else if (2 === Number(value || 0)) return "经常";
        else return "无";
    } },
    { key: 'xkr', label: '巡课人', width: 100 },
    { key: 'jxtjm', label: '教学条件', width: 100, render: value => {
        if (0 === Number(value || 0)) return "异常";
        else if (1 === Number(value || 0)) return "正常";
        else return "无";
    } },
    {
        key: 'xksj',
        label: '巡课时间',
        width: 120,
        render: (value) => {
            if (value && value.length === 6) {
                // 提取年、月、日  
                const hour = value.substring(0, 2);
                const minute = value.substring(2, 4);
                const second = value.substring(4, 6);
                // 返回格式化后的日期字符串  
                return `${hour}:${minute}:${second}`;
            } 
            return "未知格式";
        }
    },
    { key: 'sjcjsj', label: '数据采集时间', width: 200, render: value => {
        if (value && value.length === 15) {
            // 提取年、月、日  
            const year = value.substring(0, 4);
            const month = value.substring(4, 6);
            const day = value.substring(6, 8);
            const hour = value.substring(9, 11);
            const minute = value.substring(11, 13);
            const second = value.substring(13, 15);
            // 返回格式化后的日期字符串  
            return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
        } 
        return "未知格式";
    } },
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('ods/inspectionCourse/get/' + id, {})
        .then(response => response.payload.data)
        .catch(error => {
        });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('ods/inspectionCourse/list', keywords)
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('ods/inspectionCourse/insert', data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '添加成功!',
                    content: (
                        <div>
                            <p>点击确认后，返回管理页面！</p>
                        </div>
                    ),
                    onOk() {
                        DataGrid.selections = [];
                    },
                    okText: "确认",
                });
            }
        });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('ods/inspectionCourse/update/' + id, data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '更新成功!',
                    content: (
                        <div>
                            <p>点击确认后，将返回到管理页面！</p>
                        </div>
                    ),
                    onOk() {
                        DataGrid.selections = [];
                    },
                    okText: "确认",
                });
            }
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('ods/inspectionCourse/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if (DataGrid.selections.length === 0) {
        Modal.warn({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText: "确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if (response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                        DataGrid.selections = [];
                    }
                });
            },
            onCancel() { },
            okText: "确认",
            cancelText: "取消"
        });
    }
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'sysparam' + url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if (DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.warn({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText: "确认",
        });
    } else {
        redirect('/update/' + DataGrid.selections[0]);
    }
}

const getSelection = () => {
    return DataGrid.selections;
}




export default {
    insertURL: '#/sysparam/insert',
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
}